import * as React from 'react';
import { composer } from '../../../component-decorators/composer';
import { Text, Box, Heading, Button } from 'wix-style-react';
import { biLogger } from '../../../bi';
import s from './banner-holiday-sale.scss';
import { config } from '../../../config';
import { Origin, Path } from '../../../enums/marketplace-enums';
import { CounterHolidaySaleExport } from '@wix/app-market-collection-widget';
import { useConfigContext } from '../../../config-context';
export var BannerHolidaySale = composer().compose(function (_a) {
    // tslint:disable-next-line:react-hooks-nesting
    var locale = useConfigContext().locale;
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { padding: '48px 48px 37px', backgroundColor: '#0b132b', align: 'center', minWidth: '866px' },
            React.createElement(Box, { direction: 'vertical', alignSelf: 'center', align: 'center', maxWidth: '1248px', minWidth: '866px', width: "100%" },
                React.createElement(Title, null),
                React.createElement(SeeAllAppsButton, null),
                React.createElement(Box, { direction: "horizontal", verticalAlign: 'middle', align: 'center', alignSelf: 'center', marginTop: '42px' },
                    React.createElement(CounterText, null),
                    React.createElement(CounterHolidaySaleExport, { locale: locale }),
                    React.createElement(Box, { height: '42px', margin: '0 24px', width: '1px', backgroundColor: '#262c3e' }),
                    React.createElement(Disclaimer, null))))));
});
var Title = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t;
    return (React.createElement(React.Fragment, null,
        React.createElement(Heading, { appearance: "H3", style: { color: '#dd4dae' } }, t('home.holidaySale.b.pre-title')),
        React.createElement(Heading, { appearance: "H1", light: true, style: { marginTop: '6px', marginBottom: '14px' } }, t('home.holidaySale.b.title')),
        React.createElement(Heading, { appearance: "H4", light: true, style: { textAlign: 'center', width: '630px' } }, t('home.holidaySale.b.sub-title'))));
});
var SeeAllAppsButton = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t;
    return (React.createElement(Box, { minWidth: '187px' },
        React.createElement(Button, { className: s.saleButton, size: 'medium', as: "button", onClick: function () {
                biLogger.appMarketSaleCheckAllSaleAppsCollectionClick({
                    sale_name: 'nov21',
                    slug_id: 'pre-holiday-sale',
                    button_location: 'top',
                });
                config.goto({
                    path: Path.CATEGORY,
                    slug: 'pre-holiday-sale',
                    referral: 'holiday-sale-home',
                });
            } }, t('home.holidaySale.main-cta-b'))));
});
var Disclaimer = composer()
    .withMarketplaceStore()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t;
    var inStandalone = config.origin === Origin.STANDALONE;
    return (React.createElement(Text, { skin: "standard", light: true, weight: "normal", size: "tiny", className: inStandalone ? s.disclaimerStandalone : s.disclaimer }, t('home.holidaySale.disclaimer')));
});
var CounterText = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t;
    return (React.createElement(Box, { marginRight: '24px', minWidth: '246px', align: 'right' },
        React.createElement(Text, { skin: "standard", light: true, weight: "bold", size: "small" }, t('home.holidaySale.b.timer-text'))));
});
//# sourceMappingURL=banner-holiday-sale.js.map